<div
  class="avatar"
  [style.backgroundImage]="'url(' + avatarUrl() + ')'">
  @if (isFriend) {
    <div class="isFriend">
      <span class="icon-wrapper">
        <span class="icons-sprite tiny friend"></span>
      </span>
    </div>
  }
</div>
